import { XS_VIEWPORT } from '@constants/viewport';
import { useWindowSize } from '@hooks/use-window-size';
import classNames from 'classnames';

import { TabContent } from './components/tab-content';
import { TAB_TYPE_SIMPLE, TAB_TYPE_SQUARED, TabProps } from './tabs.type';

export const Tabs = ({
  activeTab,
  tabs,
  onChange,
  className,
  paddingClasses = 'pb-4',
  type = TAB_TYPE_SIMPLE,
  scrollable = true,
  secondary,
  tabColor,
  showBackground = false,
  roundedVariant,
}: TabProps) => {
  const isMobileViewPort = useWindowSize(XS_VIEWPORT);

  return (
    <div
      className={classNames(className, paddingClasses, {
        'overflow-x-auto scrollbar-hide w-full': scrollable,
      })}>
      <nav
        data-testid='tabs--navbar'
        className={classNames('inline-block whitespace-nowrap space-x-2 text-primary', {
          'space-x-2': type !== TAB_TYPE_SIMPLE,
          'space-x-4': type === TAB_TYPE_SIMPLE,
          'bg-surface-secondary p-1 rounded-md': showBackground || (isMobileViewPort && type === TAB_TYPE_SQUARED),
        })}
        aria-label='Tabs'>
        <TabContent
          type={type}
          tabs={tabs}
          activeTab={activeTab}
          secondary={secondary}
          tabColor={tabColor}
          showBackground={showBackground}
          onChange={onChange}
          roundedVariant={roundedVariant}
        />
      </nav>
    </div>
  );
};
